/**
 * @generated SignedSource<<8db3e086f813f048eb4e127567cd7ba2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type BreadcrumbForPost_post$data = {
  readonly slug: string
  readonly h1: string
  readonly parent_post: {
    readonly slug: string
    readonly h1: string
    readonly short_title: string | null
    readonly parent_post: {
      readonly slug: string
      readonly h1: string
      readonly short_title: string | null
      readonly parent_post: {
        readonly slug: string
        readonly h1: string
        readonly short_title: string | null
      } | null
    } | null
  } | null
  readonly ' $fragmentType': 'BreadcrumbForPost_post'
}
export type BreadcrumbForPost_post$key = {
  readonly ' $data'?: BreadcrumbForPost_post$data
  readonly ' $fragmentSpreads': FragmentRefs<'BreadcrumbForPost_post'>
}

const node: ReaderFragment = (function () {
  var v0 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'slug',
      storageKey: null
    },
    v1 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'h1',
      storageKey: null
    },
    v2 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'short_title',
      storageKey: null
    }
  return {
    argumentDefinitions: [],
    kind: 'Fragment',
    metadata: null,
    name: 'BreadcrumbForPost_post',
    selections: [
      v0 /*: any*/,
      v1 /*: any*/,
      {
        alias: null,
        args: null,
        concreteType: 'Post',
        kind: 'LinkedField',
        name: 'parent_post',
        plural: false,
        selections: [
          v0 /*: any*/,
          v1 /*: any*/,
          v2 /*: any*/,
          {
            alias: null,
            args: null,
            concreteType: 'Post',
            kind: 'LinkedField',
            name: 'parent_post',
            plural: false,
            selections: [
              v0 /*: any*/,
              v1 /*: any*/,
              v2 /*: any*/,
              {
                alias: null,
                args: null,
                concreteType: 'Post',
                kind: 'LinkedField',
                name: 'parent_post',
                plural: false,
                selections: [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],
                storageKey: null
              }
            ],
            storageKey: null
          }
        ],
        storageKey: null
      }
    ],
    type: 'Post',
    abstractKey: null
  }
})()

;(node as any).hash = 'a59e77ab61b9d01542836f82e3ff7e8e'

export default node
